// Pure numeric helpers for simulation lever inputs. Kept free of React so the
// clamp/snap/precision rules can be unit-tested in isolation.

/**
 * Parses a raw input string, clamps it into [min, max], snaps it to the nearest
 * `step` multiple, and trims floating-point drift.
 *
 * Returns `null` for non-numeric input so callers can treat it as a no-op
 * (leave the previous value unchanged).
 *
 * @param {string|number} raw
 * @param {number} min
 * @param {number} max
 * @param {number} [step]
 * @returns {number|null}
 */
export function clampToStep(raw, min, max, step) {
  const parsed = typeof raw === 'number' ? raw : parseFloat(raw);
  if (Number.isNaN(parsed)) return null;
  const clamped = Math.max(min, Math.min(max, parsed));
  const snapped = step ? Math.round(clamped / step) * step : clamped;
  return +snapped.toFixed(10);
}

/**
 * Formats a slider value for display. Derives decimal places from a sub-1 step
 * (e.g. step 0.01 → 2 decimals); defaults to 1 decimal otherwise.
 *
 * @param {number|null|undefined} v
 * @param {number} [step]
 * @returns {string}
 */
export function fmtVal(v, step) {
  if (v == null) return '—';
  const decimals =
    step != null && step < 1 ? Math.max(0, Math.ceil(-Math.log10(step))) : 1;
  return typeof v === 'number' ? v.toFixed(decimals) : String(v);
}
